<template>
<!-- 详情页-->
  <div class="opusInfo">
     <!-- 详情页-->
      <div class="opusInfo-con">
      <!-- 简介栏 -->
        <div class="synopsis">
          <div class="synopsis-left">
            <div class="synopsis-title">
              <div>
                <span class="bold">作者:</span>
                {{workData.nickname}}
              </div>
              <div class="status-con" v-if="userWorkId == workId">
                <span class="status bold">审核状态：<i>{{ statusData }}</i></span>
                <a class="status modify" v-if="statusData == '不通过'"  @click="toModifyMyWork">去修改</a>
              </div>
            </div>
            <div class="synopsis-title">
              <div>
                <span class="bold">作品主题：{{workData.name}}</span>
              </div>
            </div>
            <div class="synopsis-title" v-if="userWorkId == workId && statusData == '不通过'">
              <div class="synopsis-reason">
                <span class="bold title">不通过原因：</span> <span class="text">{{ workData.fail_reason }}</span>
              </div>
            </div>

            <div class="synopsis-introduce">
              <span class="bold title">作品介绍：</span>
              <i>{{workData.description}}</i>
            </div>
          </div>
          <!-- pc中点赞和拉票-->
          <!--<div class="synopsis-right" v-if="!this.$store.state.isMobile">
            <div class="thumbs-up right-button" @click="getVoteData" :class="{ 'grey':  statusData !== '通过'}">
              <img src="../assets/images/thumbs-up.png" alt="" v-if="!votesed">
              <img src="../assets/images/thumbs-up2.png" alt="" v-if="votesed">
              {{ workData.votes }}
            </div>
            <div class="canvass right-button" @click="getlocationUrl" :class="{ 'grey':  statusData !== '通过'}">
              <img src="../assets/images/canvass.png" alt="">
              拉票
            </div>
          </div>-->
        </div>
      <!-- 作品展示-->
        <div class="opus-list">
          <div class="opus-title">作品展示：</div>
<!-- app中点赞和拉票-->
          <!--<div class="synopsis-right-mobile" v-if="this.$store.state.isMobile">
            <div class="thumbs-up right-button"  @click="getVoteData" :class="{ 'grey':  statusData !== '通过'}">
              <img src="../assets/images/thumbs-up.png" alt="" v-if="!votesed">
              <img src="../assets/images/thumbs-up2.png" alt="" v-if="votesed">
              {{ workData.votes }}
            </div>
            <div class="canvass right-button"  @click="getlocationUrl" :class="{ 'grey':  statusData !== '通过'}">
              <img src="../assets/images/canvass.png" alt="">
              拉票
            </div>
          </div>-->
          <ul class="opus-list-con">
            <li v-for="item in workData.images">
              <img :src="item.url" alt="">
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "OpusInfo",
  data() {
    return{
      workData: {},
      workId: '',
      userWorkId: '',
      // 页面级变量
      pageRecord:{
        title:'precision25周年',
        module: 'precision25周年',
        category1: '作品详情页',
      },
      votesed: false,
      wrapWidth: 0,
      tipShow: false,
    }
  },
  mounted() {
    //拉票地址进入的跳转判断
    this.getSourceIsSms(window.location.href)
    //改变workId
    // this.$tool.setLS('workId', workId, 1)
    this.userWorkId = this.$tool.getLS( 'userWorkId',1)

    this.getVoteData('')
    this.getWorkData('')
    this.$nextTick(()=>{
      let $ele = this.$refs.wrap;
      if($ele &&  $ele.offsetWidth){
        this.wrapWidth = $ele.offsetWidth;
        if(this.wrapWidth > 240){
          this.tipShow = true;
        }
      }
    })
  },
  computed: {
    statusData: function() {
      let status = '';
      switch (this.workData.audit_status){
        case 0:
          status = '审核中';
          break;
        case 1:
          status = '通过';
          break;
        case 2:
          status = '不通过';
          break;
      }
      return status
    }
  },
  methods: {
    ...mapMutations(['changesmsHref',]),
    //拉片地址进入的判断
    getSourceIsSms(a) {
      //1.判断 地址栏 有没有 source
      if(a.indexOf('source')!=-1){
        console.log('有')
        //2.有 是否等于sms
        let c = a.split("source=")[1].split('&')[0]
        this.workId = a.split("&id=")[1]
        if( c == 'sms'){
          //审核短信
          //3.等于了，就判断有没有登录
          if(!this.$tool.isLogin()){
            //4.未登录就让登录
            this.$confirm('请登录！',  {
              distinguishCancelAndClose: true,
              confirmButtonText: '登录',
              cancelButtonText: '关闭'
            })
                .then(() => {
                  this.$router.push({path:'/login'});
                })
                .catch(action => {
                });
          }
        }else if(c == 'share'){
          //拉票
        }
        this.changesmsHref(a)
      }else{
        this.workId = this.$route.query.id
      }
      this.$tool.setLS('workId',  this.workId , 1)
    },
    getWorkData(style) {
      this.$api.workData( this.workId, this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
          .then(res=>{
            console.log(res)
            if(res.errCode == 0){
              this.workData = res.data
              if(style == 'vote'){
                this.votesed = true;
              }
            }else{
              this.$confirm('作品不存在!', {
                confirmButtonText: '返回首页',
                cancelButtonText: '取消',
              }).then(() => {
                this.$router.push({path:'/'});
              }).catch(() => {

              });
            }
          })
    },
    //点赞
    getVoteData(style) {
      if(this.statusData == '通过'){
        this.$api.getVote(this.workId, this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
            .then(res=>{
              if(style == ''){
                if(res.msg == '今日已投票'){
                  this.votesed = true;
                }
              }else{
                if(res.msg == '请登录'){
                  this.$confirm('请登录！',  {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '登录',
                    cancelButtonText: '关闭'
                  })
                      .then(() => {
                        this.$tool.gotoLogin();
                      })
                      .catch(action => {
                      });
                }else{
                  if(res.msg == '成功'){
                    this.$alert('点赞成功，感谢您的支持', {
                      confirmButtonText: '确定',
                      callback: action => {
                        this.getWorkData('vote')
                      }
                    });
                  }else{
                    this.$alert(res.msg, {
                      confirmButtonText: '确定',
                      callback: action => {
                        this.getWorkData('vote')
                      }
                    });
                  }
                }
              }
            })
      }else{
        if(style !== ''){
          this.$alert('作品还未审核通过!', {
            confirmButtonText: '关闭',
            callback: action => {
            }
          });
        }
      }
    },
    //拉票 复制当前地址
    getlocationUrl() {
      if(this.statusData == '通过'){
        let oInput = document.createElement("input"); //创建隐形input
        let h =  window.location.href;
        oInput.value =  h.split('/opusInfo?')[0] + '/opusInfo?source=share&'+ h.split('/opusInfo?')[1]; // window.location.href 浏览器URL
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.remove();
        // 拉票埋点
        this.gioAction('precision25thart_workshareClick', {'workstitle': this.workData.name})
        this.$alert('作品页链接已复制成功，快去分享给好友吧!', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }else{
        this.$alert('作品还未审核通过!', {
          confirmButtonText: '关闭',
          callback: action => {
          }
        });
      }
    },
    toModifyMyWork() {
      //修改的 存储作品信息 用作上传的回填
      this.$tool.setLS('myWorkList',  this.workData ,1)
      this.$router.push({ path:'/uploadOpus'});
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/OpusInfo/pc";
@import "../assets/css/OpusInfo/wap";
</style>
